// extracted by mini-css-extract-plugin
export default {"ThemeSwitcher":"ThemeSwitcher_ThemeSwitcher__ZhIJS"};